(() => {
  const root = window.Shopify?.routes?.root || '/';
  const formatMoney = (cents, currency) => new Intl.NumberFormat(document.documentElement.lang === 'en' ? 'en-GB' : 'fr-FR', {maximumFractionDigits:0}).format(cents / 100) + ' DH';
  const readQuantity = input => {
    const quantity = Number(input.value);
    return Number.isSafeInteger(quantity) && quantity >= 0 && quantity <= 6 ? quantity : null;
  };
  if (!customElements.get('cnm-cookie-builder')) {
    customElements.define('cnm-cookie-builder', class extends HTMLElement {
      connectedCallback() {
        this.events?.abort();
        this.events = new AbortController();
        this.inputs = [...this.querySelectorAll('[data-cookie-quantity]')];
        this.form = this.querySelector('form');
        this.busy = false;
        this.addEventListener('click', event => {
          const button = event.target.closest('[data-step]');
          if (!button || this.busy) return;
          const input = button.parentElement.querySelector('input');
          const current = readQuantity(input) ?? 0;
          if (Number(button.dataset.step) > 0 && this.selection().reduce((sum, item) => sum + (item.quantity || 0), 0) >= 6) return;
          input.value = Math.max(0, Math.min(6, current + Number(button.dataset.step)));
          this.update();
        }, {signal:this.events.signal});
        this.addEventListener('input', () => this.update(), {signal:this.events.signal});
        this.form.addEventListener('submit', event => this.submit(event), {signal:this.events.signal});
        this.update();
      }
      disconnectedCallback() { this.events?.abort(); }
      selection() {
        return this.inputs.map(input => ({input, quantity:readQuantity(input), id:input.dataset.variant, price:Number(input.dataset.price)}));
      }
      update() {
        const selection = this.selection();
        const valid = selection.every(item => item.quantity !== null);
        const quantity = selection.reduce((sum, item) => sum + (item.quantity || 0), 0);
        const total = selection.reduce((sum, item) => sum + (item.quantity || 0) * item.price, 0);
        this.querySelector('[data-cookie-count]').textContent = quantity + (quantity > 1 ? window.cnmText(" cookies sélectionnés") : window.cnmText(" cookie sélectionné"));
        this.querySelector('[data-cookie-total]').textContent = formatMoney(total, this.dataset.currency);
        this.querySelector('[data-cookie-minimum]').textContent = !valid ? window.cnmText("Saisissez des quantités entières entre 0 et 6.") : quantity < 6 ? window.cnmText("Encore ") + (6 - quantity) + (6 - quantity > 1 ? ' cookies' : ' cookie') + window.cnmText(" pour composer votre boîte.") : quantity > 6 ? window.cnmText("Votre boîte doit contenir exactement 6 cookies.") : window.cnmText("Votre boîte est prête à être ajoutée.");
        this.querySelector('[type="submit"]').disabled = this.busy || !valid || quantity !== 6;
        selection.forEach(item => {
          item.input.parentElement.querySelector('[data-step="-1"]').disabled = this.busy || !item.quantity;
          item.input.parentElement.querySelector('[data-step="1"]').disabled = this.busy || quantity >= 6;
        });
        return {selection, valid, quantity};
      }
      async submit(event) {
        event.preventDefault();
        if (this.busy) return;
        const state = this.update();
        const error = this.querySelector('[data-cookie-error]');
        if (!state.valid || state.quantity !== 6) {
          error.textContent = window.cnmText("Choisissez exactement 6 cookies pour composer votre boîte.");
          error.hidden = false;
          return;
        }
        error.hidden = true;
        this.busy = true;
        this.update();
        this.querySelector('fieldset').disabled = true;
        const group = window.crypto?.randomUUID?.() || Date.now().toString(36) + Math.random().toString(36).slice(2);
        const items = state.selection.filter(item => item.quantity > 0).map(item => ({
          id:item.id, quantity:item.quantity, properties:{'_cnm_cookie_box':group, 'Coffret':window.cnmText("Boîte de 6 cookies à composer"), 'Composition':state.quantity + window.cnmText(" cookies au total")}
        }));
        try {
          const response = await fetch(root + 'cart/add.js', {method:'POST', headers:{'Content-Type':'application/json', 'Accept':'application/json'}, body:JSON.stringify({items})});
          const result = await response.json();
          if (!response.ok || result.status) throw new Error(result.description || result.message || window.cnmText("Impossible d’ajouter votre boîte. Réessayez."));
          window.location.assign(root + 'cart');
        } catch (failure) {
          error.textContent = typeof failure.message === 'string' ? failure.message : window.cnmText("Impossible d’ajouter votre boîte. Réessayez.");
          error.hidden = false;
          this.busy = false;
          this.querySelector('fieldset').disabled = false;
          this.update();
        }
      }
    });
  }
  const checkCookieBoxes = cart => {
    const groups = new Map();
    for (const item of cart.items || []) {
      if (item.product_type !== 'Cookies à composer' && !item.properties?._cnm_cookie_box) continue;
      const group = item.properties?._cnm_cookie_box || 'manual';
      groups.set(group, (groups.get(group) || 0) + item.quantity);
    }
    return {contains:groups.size > 0, invalid:[...groups.values()].some(quantity => quantity > 0 && quantity !== 6)};
  };
  const renderCookieCart = cart => {
    const status = checkCookieBoxes(cart);
    document.querySelectorAll('button[name="checkout"],input[name="checkout"]').forEach(button => {
      if (status.invalid && !button.disabled) {
        button.dataset.cnmCookieDisabled = 'true';
        button.disabled = true;
      } else if (!status.invalid && button.dataset.cnmCookieDisabled === 'true') {
        button.disabled = false;
        delete button.dataset.cnmCookieDisabled;
      }
    });
    document.querySelectorAll('.additional-checkout-buttons,.cart__dynamic-checkout-buttons').forEach(element => {
      if (status.contains && !element.hidden) {element.hidden = true;element.dataset.cnmCookieHidden = 'true';}
      else if (!status.contains && element.dataset.cnmCookieHidden === 'true') {element.hidden = false;delete element.dataset.cnmCookieHidden;}
    });
    document.querySelectorAll('[data-cnm-cookie-cart-error]').forEach(element => element.remove());
    if (status.invalid) {
      const places = [document.querySelector('#main-cart-footer .cart__blocks'),document.querySelector('cart-drawer .cart-drawer__footer')].filter(Boolean);
      places.forEach(place => {
        const message = document.createElement('div');
        message.className = 'cnm-cookie-minimum-error';
        message.dataset.cnmCookieCartError = '';
        message.setAttribute('role','alert');
        message.append(window.cnmText("Chaque boîte à composer doit contenir exactement 6 cookies. Ajustez les quantités ou retirez la boîte entière. "));
        const link = document.createElement('a');link.href = root + 'products/cookies-a-composer';link.textContent = window.cnmText("Composer une boîte");
        message.append(link);
        place.prepend(message);
      });
    }
    return status;
  };
  const getCart = async () => {
    const response = await fetch(root + 'cart.js', {headers:{Accept:'application/json'}, cache:'no-store'});
    if (!response.ok) throw new Error(window.cnmText("Impossible de vérifier votre boîte. Réessayez."));
    return response.json();
  };
  const initial = document.querySelector('[data-cnm-cookie-initial-cart]');
  if (initial) {try {renderCookieCart(JSON.parse(initial.textContent));} catch {}}
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, event => {
      if (event.cartData?.items) renderCookieCart(event.cartData);
      else getCart().then(renderCookieCart).catch(() => {});
    });
  }
  let checking = false;
  const validateCheckout = async () => {
    if (checking) return;
    checking = true;
    try {
      const cart = await getCart();
      const status = renderCookieCart(cart);
      if (status.invalid) {
        document.querySelector('[data-cnm-cookie-cart-error]')?.scrollIntoView({behavior:'smooth',block:'center'});
        return;
      }
      window.location.assign(root + 'checkout');
    } catch (failure) {
      const place = document.querySelector('#cart-errors') || document.querySelector('#CartDrawer-CartErrors');
      if (place) place.textContent = failure.message;
    } finally {checking = false;}
  };
  document.addEventListener('click', event => {
    const target = event.target.closest?.('button[name="checkout"],input[name="checkout"],a[href]');
    if (!target) return;
    const checkout = target.matches('[name="checkout"]') || target.matches('a') && new URL(target.href,location.href).pathname.split('/').filter(Boolean).at(-1) === 'checkout';
    if (!checkout) return;
    if (target.form && !target.form.reportValidity()) return;
    event.preventDefault();event.stopImmediatePropagation();validateCheckout();
  },true);
  document.addEventListener('submit', event => {
    if (event.submitter?.name !== 'checkout') return;
    event.preventDefault();event.stopImmediatePropagation();validateCheckout();
  },true);
})();
